import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/shared/lead';
import '~/app/assets/javascripts/application/static_page/common';
